import { render } from "./HelpCenterLink.vue?vue&type=template&id=04c0218a"
import script from "./HelpCenterLink.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpCenterLink.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/HelpCenterLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04c0218a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04c0218a', __exports__)) {
    api.reload('04c0218a', __exports__)
  }
  
  module.hot.accept("./HelpCenterLink.vue?vue&type=template&id=04c0218a", () => {
    api.rerender('04c0218a', render)
  })

}


export default __exports__